import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@app/../environments/environment';
import { State, select$ } from '@app/shared/helpers/store';
import { first, skipWhile, take } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';
import { UsersService } from '@app/services/users/users.service';
import { Store } from '@ngrx/store';
import { IUser } from '@app/models/user.interface';
import { selectCoreState, selectMeState } from '@app/core/store/core.selectors';
import { LabelLogoService } from '@app/services/label-logo/label-logo.service';

@Injectable({
  providedIn: 'root'
})
export class ImageUploadService {
  public endpoint:string = environment.apiUrl + '/image-upload';
  public imageLogoData$: State<any>;
  public imageLogo$: Observable<any>;
  public imageReportLogoData$: State<any>;
  public imageReportLogo$: Observable<any>;
  public imageProductData$: State<any>;
  public imageProduct$: Observable<any>;
  public croppedImageData$: State<any>;
  public croppedImage$: Observable<any>;
  public profileLogoData$: State<any>;
  public profileLogo$: Observable<any>;

  constructor(
    private http: HttpClient,
    @Inject(DOCUMENT) private document: Document,
    private _users: UsersService,
    private store$: Store,
    private _labelLogo: LabelLogoService
  ) { 
    this.imageLogoData$ = new State('');
    this.imageLogo$ = select$(this.imageLogoData$, data => data);
    this.imageReportLogoData$ = new State('');
    this.imageReportLogo$ = select$(this.imageReportLogoData$, data => data);
    this.imageProductData$ = new State(null);
    this.imageProduct$ = select$(this.imageProductData$, data => data);
    this.croppedImageData$  = new State(null);
    this.croppedImage$ = select$(this.croppedImageData$, data => data);
    this.profileLogoData$  = new State(null);
    this.profileLogo$ = select$(this.profileLogoData$, data => data);
  }

  /**
   * 
   * @param image Base 64 image for company logo.
   * @returns 
   */
  public onStoreLogo(image){
    return this.http.post<any>(`${this.endpoint}`, {
      image:image
    }).subscribe(()=> {
      this.imageLogoData$.next(image);
    });
  }

  public onGetLogo(){
    return this.http.get<any>(`${this.endpoint}`).subscribe((res)=> {
      if(res == null){
        this.imageLogoData$.next(null);
      }
      this.imageLogoData$.next(res);
    });
  }

  /**
   * Caches the location logo so the DYMO shipping labels can embed it.
   * The label templates read it from localStorage at print time.
   */
  public cacheLogoForLabelPrinting(){
    return this._labelLogo.cacheForPrinting();
  }

  public onResetLogo(){
    return this.http.get<any>(`${this.endpoint}/reset`).pipe(first()).subscribe(()=> {
      this.imageLogoData$.next(false);
      this.onGetLogo();
    });
  }

  /**
   * Report Logo
   */
   public onGetReportLogo(){
    return this.http.get<any>(`${this.endpoint}/report`).subscribe((res)=> {
      this.imageReportLogoData$.next(res);
    });
  }

  public onStoreReportLogo(image){
    return this.http.post<any>(`${this.endpoint}/report`, {
      image:image
    }).pipe(first()).subscribe((res)=> {
      this.onGetReportLogo();
    });
  }

  public onResetReportLogo(){
    return this.http.get<any>(`${this.endpoint}/reset-report`).pipe(first()).subscribe(()=> {
      this.onGetReportLogo();
    });
  }

  public onPostProfileImage(image){
    let user;
    this.store$.select(selectMeState).pipe(
      skipWhile(res => res == null),
      take(1)
    ).subscribe((me) =>  {
      user = me;
    });

    return this.http.post<any>(`${this.endpoint}/profile`, {
      image:image,
      usrID: user.usrID
    });
  }

  public onGetProfileLogo(): Observable<any>{
    return this.http.get<any>(`${this.endpoint}/profile`);
  }

  public onDeleteProfileLogo(){
    const user = this._users.currentUserData$.getValue();
    return this.http.delete<any>(`${this.endpoint}/profile`);
  }

  /**
   * 
   * @param image Asset Product Images
   */
  public onSetProductImage(image){
    this.imageProductData$.next(image);
  }

  public onSetCroppedImage(image){
    this.croppedImageData$.next(image);
  }

  public onFinishCroppedImage(){
    this.croppedImageData$.next(null);
  }

  public onSetLogoUpload(){
    const htmlTag = this.document.getElementById('app-theme');

  }

  public onSetFinishUpload(){
    const htmlTag = this.document.getElementById('app-theme');
  }

}
